"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showCallInReplyBar = exports.showContactInReplyBar = exports.showPureSubmitInReplyBar = exports.showCaptionLgInReplyBar = exports.showTitleAndCaptionInReplyBar = exports.showWhatsappInReplyBar = exports.getAllState = void 0;
var pageToName_1 = require("@/utils/pageToName");
var Pages_1 = require("@/rendering/common/Pages");
exports.getAllState = function (page) {
    return "SET_ALL_STATE_" + pageToName_1.pageToName(page);
};
exports.showWhatsappInReplyBar = function (page) {
    switch (page) {
        case Pages_1.Pages.HOME:
        case Pages_1.Pages.PROPERTY_DETAIL:
        case Pages_1.Pages.DEVELOPMENT:
        case Pages_1.Pages.DEVELOPMENTS:
            return false;
        default:
            return true;
    }
};
exports.showTitleAndCaptionInReplyBar = function (page) {
    return true;
    // switch (page) {
    //   case Pages.HOME:
    //     return false;
    //   default:
    //     return true;
    // }
};
exports.showCaptionLgInReplyBar = function (page) {
    return false;
    // switch (page) {
    //   case Pages.HOME:
    //     return true;
    //   default:
    //     return false;
    // }
};
exports.showPureSubmitInReplyBar = function (page) {
    switch (page) {
        case Pages_1.Pages.HOME:
        case Pages_1.Pages.PROPERTY_DETAIL:
        case Pages_1.Pages.DEVELOPMENT:
        case Pages_1.Pages.DEVELOPMENTS:
            return true;
        default:
            return false;
    }
};
exports.showContactInReplyBar = function (page) {
    switch (page) {
        case Pages_1.Pages.HOME:
        case Pages_1.Pages.PROPERTY_DETAIL:
        case Pages_1.Pages.DEVELOPMENT:
        case Pages_1.Pages.DEVELOPMENTS:
            return true;
        default:
            return false;
    }
};
exports.showCallInReplyBar = function (page) {
    console.log(page);
    switch (page) {
        case Pages_1.Pages.HOME:
        case Pages_1.Pages.PROPERTY_DETAIL:
        case Pages_1.Pages.DEVELOPMENT:
        case Pages_1.Pages.DEVELOPMENTS:
            return false;
        default:
            return true;
    }
};
